'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;

var _mobx = require('mobx');

var _ApplicationStore = require('../stores/ApplicationStore');

var _ApplicationStore2 = _interopRequireDefault(_ApplicationStore);

var _CapitalFundingStore = require('../stores/CapitalFundingStore');

var _CapitalFundingStore2 = _interopRequireDefault(_CapitalFundingStore);

var _CaseUpdateStoreClass = require('../stores/CaseUpdateStoreClass');

var _CaseUpdateStoreClass2 = _interopRequireDefault(_CaseUpdateStoreClass);

var _ClientsClass = require('../clients/ClientsClass');

var _ClientsClass2 = _interopRequireDefault(_ClientsClass);

var _ContactStoreClass = require('../stores/ContactStoreClass');

var _ContactStoreClass2 = _interopRequireDefault(_ContactStoreClass);

var _DefendantStore = require('../stores/DefendantStore');

var _DefendantStore2 = _interopRequireDefault(_DefendantStore);

var _DefendantInsurerStoreClass = require('../stores/DefendantInsurerStoreClass');

var _DefendantInsurerStoreClass2 = _interopRequireDefault(_DefendantInsurerStoreClass);

var _FlatStore = require('../stores/FlatStore');

var _FlatStore2 = _interopRequireDefault(_FlatStore);

var _FunderStoreClass = require('../stores/FunderStoreClass');

var _FunderStoreClass2 = _interopRequireDefault(_FunderStoreClass);

var _InsurerStore = require('../stores/InsurerStore');

var _InsurerStore2 = _interopRequireDefault(_InsurerStore);

var _LienStore = require('../stores/LienStore');

var _LienStore2 = _interopRequireDefault(_LienStore);

var _LinkCopyStoreClass = require('../stores/LinkCopyStoreClass');

var _LinkCopyStoreClass2 = _interopRequireDefault(_LinkCopyStoreClass);

var _OptionsStoreClass = require('../stores/OptionsStoreClass');

var _OptionsStoreClass2 = _interopRequireDefault(_OptionsStoreClass);

var _PartyStore = require('../stores/PartyStore');

var _PartyStore2 = _interopRequireDefault(_PartyStore);

var _PlaintiffStore = require('../stores/PlaintiffStore');

var _PlaintiffStore2 = _interopRequireDefault(_PlaintiffStore);

var _PriorFundingStore = require('../stores/PriorFundingStore');

var _PriorFundingStore2 = _interopRequireDefault(_PriorFundingStore);

var _ReportStore = require('../stores/ReportStore');

var _ReportStore2 = _interopRequireDefault(_ReportStore);

var _UiStoreClass = require('../stores/UiStoreClass');

var _UiStoreClass2 = _interopRequireDefault(_UiStoreClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

// Importing all from '../stores' causes an import loop in Jest


var AppState = (_class = function () {
  function AppState() {
    _classCallCheck(this, AppState);

    _initDefineProp(this, 'ApplicationStore', _descriptor, this);

    _initDefineProp(this, 'CapitalFundingStore', _descriptor2, this);

    _initDefineProp(this, 'CaseStore', _descriptor3, this);

    _initDefineProp(this, 'CaseUpdateStore', _descriptor4, this);

    _initDefineProp(this, 'ContactStore', _descriptor5, this);

    _initDefineProp(this, 'DefendantStore', _descriptor6, this);

    _initDefineProp(this, 'DefendantInsurerStore', _descriptor7, this);

    _initDefineProp(this, 'FlatStore', _descriptor8, this);

    _initDefineProp(this, 'FunderStore', _descriptor9, this);

    _initDefineProp(this, 'InsurerStore', _descriptor10, this);

    _initDefineProp(this, 'LienStore', _descriptor11, this);

    _initDefineProp(this, 'LinkCopyStore', _descriptor12, this);

    _initDefineProp(this, 'OptionsStore', _descriptor13, this);

    _initDefineProp(this, 'PartyStore', _descriptor14, this);

    _initDefineProp(this, 'PlaintiffStore', _descriptor15, this);

    _initDefineProp(this, 'PriorFundingStore', _descriptor16, this);

    _initDefineProp(this, 'ReportStore', _descriptor17, this);

    _initDefineProp(this, 'SessionStore', _descriptor18, this);

    _initDefineProp(this, 'UiStore', _descriptor19, this);

    _initDefineProp(this, 'Clients', _descriptor20, this);
  }

  _createClass(AppState, [{
    key: 'init',


    // Importing CaseStore and SessionStore in this file breaks everything
    // istanbul ignore next
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(CaseStoreClass, SessionStoreClass, transport) {
        var uiStore, flatStore, caseUpdateStore, clients, linkCopyStore, partyStore, optionsStore, caseStore, applicationStore, contactStore, funderStore, defendantStore, defendantInsurerStore, insurerStore, lienStore, plaintiffStore, sessionStore, capitalFundingStore, priorFundingStore, reportStore;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // No requirements
                uiStore = new _UiStoreClass2.default(), flatStore = new _FlatStore2.default(), caseUpdateStore = new _CaseUpdateStoreClass2.default(), clients = new _ClientsClass2.default(transport), linkCopyStore = new _LinkCopyStoreClass2.default(transport), partyStore = new _PartyStore2.default(transport), optionsStore = new _OptionsStoreClass2.default(transport), caseStore = new CaseStoreClass(flatStore, transport), applicationStore = new _ApplicationStore2.default(flatStore, caseStore, transport), contactStore = new _ContactStoreClass2.default(caseStore, transport), funderStore = new _FunderStoreClass2.default(caseStore, transport), defendantStore = new _DefendantStore2.default(caseStore, transport), defendantInsurerStore = new _DefendantInsurerStoreClass2.default(caseStore, transport), insurerStore = new _InsurerStore2.default(caseStore, transport), lienStore = new _LienStore2.default(flatStore, caseStore, transport), plaintiffStore = new _PlaintiffStore2.default(caseStore, transport), sessionStore = new SessionStoreClass(funderStore, transport), capitalFundingStore = new _CapitalFundingStore2.default(flatStore, lienStore, transport), priorFundingStore = new _PriorFundingStore2.default(lienStore, sessionStore, transport), reportStore = new _ReportStore2.default(transport, sessionStore, funderStore, uiStore);


                this.ApplicationStore = applicationStore;
                this.CapitalFundingStore = capitalFundingStore;
                this.CaseStore = caseStore;
                this.CaseUpdateStore = caseUpdateStore;
                this.Clients = clients;
                this.ContactStore = contactStore;
                this.DefendantStore = defendantStore;
                this.DefendantInsurerStore = defendantInsurerStore;
                this.FlatStore = flatStore;
                this.FunderStore = funderStore;
                this.InsurerStore = insurerStore;
                this.LienStore = lienStore;
                this.LinkCopyStore = linkCopyStore;
                this.OptionsStore = optionsStore;
                this.PartyStore = partyStore;
                this.PlaintiffStore = plaintiffStore;
                this.PriorFundingStore = priorFundingStore;
                this.ReportStore = reportStore;
                this.SessionStore = sessionStore;
                this.UiStore = uiStore;

                _context.next = 23;
                return sessionStore.transport.getAuthentication({});

              case 23:
                _context.next = 25;
                return funderStore.setSessionStore(sessionStore);

              case 25:
                _context.next = 27;
                return linkCopyStore.fetch();

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return AppState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'ApplicationStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'CapitalFundingStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'CaseStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'CaseUpdateStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'ContactStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'DefendantStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'DefendantInsurerStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'FlatStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'FunderStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'InsurerStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'LienStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'LinkCopyStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'OptionsStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'PartyStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'PlaintiffStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'PriorFundingStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'ReportStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'SessionStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'UiStore', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'Clients', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class);

var _default = new AppState();

exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AppState, 'AppState', '/app/src/lib/AppState.js');
  reactHotLoader.register(_default, 'default', '/app/src/lib/AppState.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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